/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateSearchResponseDTO interface.
 */
export function instanceOfCreateSearchResponseDTO(value) {
    return true;
}
export function CreateSearchResponseDTOFromJSON(json) {
    return CreateSearchResponseDTOFromJSONTyped(json, false);
}
export function CreateSearchResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'searchIds': json['searchIds'] == null ? undefined : json['searchIds'],
        'releasedAsinCount': json['releasedAsinCount'] == null ? undefined : json['releasedAsinCount'],
        'heldAsinCount': json['heldAsinCount'] == null ? undefined : json['heldAsinCount'],
    };
}
export function CreateSearchResponseDTOToJSON(json) {
    return CreateSearchResponseDTOToJSONTyped(json, false);
}
export function CreateSearchResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'searchIds': value['searchIds'],
        'releasedAsinCount': value['releasedAsinCount'],
        'heldAsinCount': value['heldAsinCount'],
    };
}
